import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageService } from 'primeng/api';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  constructor(private messageService: MessageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // CORS / Network error usually comes with status 0
        if (error.status === 0) {
          this.messageService.add({
            severity: 'error',
            summary: 'Network/CORS Error',
            detail: 'Cannot reach server. Possible CORS issue.',
            key: 'global-error'
          });
        }

        return throwError(() => error);
      })
    );
  }
}
